import React, { PureComponent } from "react";
import { FloatingActionButton, Divider } from "material-ui";
import ContentAdd from "material-ui/svg-icons/content/add";
import ContentRemove from "material-ui/svg-icons/content/remove";
import { Field, FieldArray } from "redux-form";
import {
	SelectField,
	TextField,
	SelectField as RFSelectField,
	DatePicker
} from "redux-form-material-ui";
import Util from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import {
	typeInteger,
	required,
	noUnderscore,
	onlyWords
} from "../../common/validaciones";
import { MODE_CRU_CREATE } from "../../actions/ActionConstants";
import InputMask from "../InputMask/InputMask";
import "./AddFamily.css";

class AddFamily extends PureComponent {
	constructor() {
		super();
		this.renderFields = this.renderFields.bind(this);
	}

	renderFields({ fields }) {
		return (
			<div className="top20">
				<div className="columns-row-between align-center">
					<div className="titlePhoneContainer">
						<h4
							className="titleAddPhone text-center"
							style={{ color: "#70787d" }}
						>
							Agregar Nuevos Familiares
						</h4>
						<Divider className="top10" />
					</div>
					<FloatingActionButton
						zDepth={1}
						onClick={() => fields.push()}
						disabled={this.props.disabled ? this.props.disabled : false}
					>
						<ContentAdd />
					</FloatingActionButton>
				</div>
				<div className="columns-row-container">
					{fields.map((family, index) => (
						<div
							key={index}
							className="columns-column-between columns-full align-center bottom20"
						>
							<div className="columns-row-between columns-full align-center">
								<Field
									name={`${family}.${this.props.nameFieldType}`}
									component={SelectField}
									floatingLabelText="Parentesco"
									fullWidth
									validate={required}
									style={this.props.selectStyle}
									className={this.props.selectClass}
								>
									{UtilPC.renderSelectFieldItemsArray(
										this.props.relationshipsTypeList
									)}
								</Field>
								<Field
									name={`${family}.${this.props.nameFieldDNI}`}
									fullWidth
									component={InputMask}
									validate={[noUnderscore, typeInteger, required]}
									floatingLabelText="Nro. de documento"
									mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
									floatingLabelFixed={this.props.modeCRU === MODE_CRU_CREATE}
									style={this.props.inputNumberStyle}
									className="left10"
								/>
								<Field
									name={`${family}.${this.props.nameFieldSurname}`}
									component={TextField}
									floatingLabelText="Apellido"
									fullWidth
									validate={[onlyWords, required]}
									style={this.props.inputNumberStyle}
									className="left10"
								/>
								<Field
									name={`${family}.${this.props.nameFieldName}`}
									component={TextField}
									floatingLabelText="Nombre"
									fullWidth
									validate={[onlyWords, required]}
									style={this.props.inputNumberStyle}
									className="left10"
								/>
							</div>
							<div className="columns-row-around columns-full align-center">
								<Field
									name={`${family}.${this.props.nameFieldGender}`}
									component={RFSelectField}
									floatingLabelText="Sexo"
								>
									{UtilPC.renderSelectFieldItemsArray(this.props.gendersList)}
								</Field>
								<Field
									name={`${family}.${this.props.nameFieldBirthDate}`}
									component={DatePicker}
									floatingLabelText="Fecha de nacimiento"
									format={Util.isoDateToJavascriptDate}
									DateTimeFormat={Intl.DateTimeFormat}
									locale="es-ES"
									maxDate={new Date()}
									parse={v => Util.formatDateToISODate(v)}
								/>

								<FloatingActionButton
									mini
									backgroundColor="#F44534"
									zDepth={1}
									onClick={() => fields.remove(index)}
									disabled={this.props.disabled ? this.props.disabled : false}
								>
									<ContentRemove />
								</FloatingActionButton>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}

	render() {
		return (
			<FieldArray
				name={this.props.nameFieldArray}
				component={this.renderFields}
			/>
		);
	}
}

export default AddFamily;



// WEBPACK FOOTER //
// ./src/components/AddFamily/AddFamily.js